import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Table, Collapse } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { URLS } from "../../Url"
import axios from "axios"

const FAQ = () => {
  var GetAuth = localStorage.getItem("authUser")
  var TokenJson = JSON.parse(GetAuth)
  var TokenData = TokenJson.token
  const [Data, setData] = useState([])

  useEffect(() => {
    Get()
  }, [])

  const Get = () => {
    var token = TokenData
    axios
      .post(
        URLS.GetFaq,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setData(res.data.faqs)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="FAQ's" />
          <Row>
            <Card>
              <CardBody>
                <div className="text-center mb-1">
                  <h3 className="text-primary">Frequently Asked Questions</h3>
                </div>
                <hr></hr>
                {Data.map((data, key) => (
                  <div className="faq-box d-flex mb-1 pt-2" key={key}>
                    <div className="flex-shrink-0 me-1 faq-icon">
                      <i className="bx bx-help-circle font-size-20 text-success"></i>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-15">{data.question} ?</h5>
                      <p className="text-muted">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.answer,
                          }}
                        ></div>
                      </p>
                    </div>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default FAQ
